import { useTranslation } from 'react-i18next';

const values = [
  {
    icon: 'ri-building-2-line',
    titleKey: 'value.suppliers.title',
    descKey: 'value.suppliers.desc',
  },
  {
    icon: 'ri-stack-line',
    titleKey: 'value.moq.title',
    descKey: 'value.moq.desc',
  },
  {
    icon: 'ri-magic-line',
    titleKey: 'value.ai.title',
    descKey: 'value.ai.desc',
  },
  {
    icon: 'ri-shield-check-line',
    titleKey: 'value.transparent.title',
    descKey: 'value.transparent.desc',
  },
];

export default function ValueCards() {
  const { t } = useTranslation('home');

  return (
    <section className="w-full bg-warm-50/60 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="max-w-7xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block text-xs font-semibold text-warm-500 uppercase tracking-[0.2em] mb-4">
              {t('value.sectionLabel') || 'Why GBCOSPACK'}
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-800 max-w-3xl mx-auto leading-tight">
              {t('value.sectionTitle') || 'Global sourcing, simplified'}
            </h2>
            <div className="w-16 h-1 bg-warm-500 mx-auto mt-6 rounded-full" />
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
            {values.map((item, index) => (
              <div
                key={item.titleKey}
                className="group relative bg-white rounded-xl border border-ink-100 hover:border-warm-400/40 shadow-sm hover:shadow-lg hover:shadow-warm-500/5 transition-all duration-500 overflow-hidden"
              >
                {/* Accent top bar */}
                <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-warm-400 to-warm-500 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left" />
                
                <div className="p-7 md:p-9">
                  {/* Number badge */}
                  <div className="flex items-center justify-between mb-6">
                    <div className="w-14 h-14 md:w-16 md:h-16 rounded-xl bg-warm-50 flex items-center justify-center group-hover:bg-warm-500 group-hover:text-white transition-all duration-300">
                      <i className={`${item.icon} text-warm-500 group-hover:text-white text-2xl md:text-3xl transition-colors duration-300`} />
                    </div>
                    <span className="text-3xl md:text-4xl font-black text-ink-100 group-hover:text-warm-200 transition-colors duration-300">
                      {String(index + 1).padStart(2, '0')}
                    </span>
                  </div>

                  <h3 className="text-base md:text-lg font-bold text-ink-800 mb-3 group-hover:text-ink-900 transition-colors">
                    {t(item.titleKey)}
                  </h3>
                  <p className="text-sm text-ink-500 leading-relaxed">
                    {t(item.descKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}